module.exports={
OopsTryAgain:'Oops! Something went wrong. Please try again. If the problem persists please contact technical support.'};
//# sourceMappingURL=errorMessages.js.map
